import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "app-back-button",
    templateUrl: "./back-button.component.html",
    styleUrls: ["./back-button.component.scss"],
    standalone: false
})
export class BackButtonComponent {
  @Input() text: string = '';
  @Output() clicked = new EventEmitter<void>();
  @Input() isDisabled?: boolean = false;

  onClickButton() {
    this.clicked.emit();
  }
}
